import { render, staticRenderFns } from "./settingAi.vue?vue&type=template&id=ffb308b4&scoped=true&"
import script from "./settingAi.vue?vue&type=script&lang=js&"
export * from "./settingAi.vue?vue&type=script&lang=js&"
import style0 from "./settingAi.vue?vue&type=style&index=0&id=ffb308b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb308b4",
  null
  
)

export default component.exports